var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGy(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 512,
    width: 512,
    id: "flag-icon-css-gy",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#399408",
    d: "M1.946 0H512v512H1.946z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.14 0c-.673.078 495.688 257.58 495.688 257.58L-.002 511.75.14 0z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.23 21.532c2.768 0 447.253 232.41 444.722 234.7L1.494 494.152.23 21.532z",
    fill: "#ffde08"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.495.836c1.478 0 232.762 256.98 232.762 256.98L1.495 508.776V.826z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.23 36.162c1.325-15.985 208.733 222.29 208.733 222.29L.23 481.812V36.162z",
    fill: "#de2110"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGy);
export default __webpack_public_path__ + "static/media/gy.55fe67473c4b7e1d63feafcad26bafc5.svg";
export { ForwardRef as ReactComponent };